import { params } from '@app/configurations';
import { CustomerUser } from '../models/customer.models';
import { User, UserAccessLevel, UserRole } from '../models/user.models';
import { getQueryParameter } from './url.utilities';

export function getAccessRoles(role: UserRole): UserRole[] {
  const idx = UserAccessLevel.indexOf(role);

  return UserAccessLevel.filter((_, i) => i <= idx);
}

export function hasAccess(role: UserRole, required: UserRole): boolean {
  return UserAccessLevel.indexOf(role) >= UserAccessLevel.indexOf(required);
}

export function userToFullName(user: { firstName?: string; lastName?: string; email?: string }): string {
  return `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || user?.email.split('@')[0].replace('.', ' ');
}

export function getUserInitials(user: User | CustomerUser): string {
  let initials = '';

  if (!user) {
    return initials;
  }

  const firstName = user.firstName?.trim() || '';
  const lastName = user.lastName?.trim() || '';
  const email = user.email?.trim() || '';

  if (firstName && lastName) {
    initials = `${firstName[0]}${lastName[0]}`;
  }

  if (firstName.length >= 2) {
    initials = firstName.slice(0, 2);
  }

  if (lastName.length >= 2) {
    initials = lastName.slice(0, 2);
  }

  if (email.length >= 2) {
    initials = email.slice(0, 2);
  }

  return initials.toLocaleUpperCase();
}

export function logout(): void {
  location.href = `${location.origin}/portal/logout`;
}

export function toImpersonate(): string {
  return getQueryParameter(params.IMPERSONATION_ID) as string;
}
